import { FC } from "react";
import "../../i18n";
import styles from "./PageLoader.module.css";
import { Spinner } from "./Spinner";

const PageLoader: FC = () => {
  return (
    <div className={styles["pageLoader"]}>
      <Spinner />
    </div>
  );
};

export default PageLoader;
